import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';
import { ComboBoxOption } from '../controls/ComboBox';

interface ISelectionBoxInputs {
  name: string;
  label: string;
  options: ComboBoxOption[];
  required?: boolean;
}

export function SelectionBox(props: ISelectionBoxInputs) {
  const { name, label, options, required = false } = props;
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  const IsOptionSelected = async (option: ComboBoxOption) => {
    if (!required) return true;
    if (option === null || undefined) return false;
    if (option.label === null || option.label === undefined) return false;
    return option.label.length > 0;
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: required, validate: IsOptionSelected }}
      defaultValue={null}
      render={({ field }) => (
        <Autocomplete
          {...field}
          {...register(name)}
          id={name}
          options={options}
          getOptionLabel={(option: ComboBoxOption) => option.label || ''}
          onChange={(_, option) => field.onChange(option)}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          autoHighlight
          autoSelect
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              error={Boolean(errors[name])}
              helperText={errors[name] && `${label} is Required`}
            />
          )}
        />
      )}
    />
  );
}
